import { apiFetch } from "./client.js";

let teamsCache = null;
const invoiceSettingsCache = new Map();

export function clearTeamsCache() {
  teamsCache = null;
}

export function fetchTeams(options = {}) {
  const { force = false, ...apiOptions } = options;

  if (!force && teamsCache) {
    return teamsCache;
  }

  teamsCache = apiFetch("/teams", apiOptions).catch((err) => {
    teamsCache = null;
    throw err;
  });

  return teamsCache;
}

export function clearTeamInvoiceSettingsCache(teamId) {
  if (teamId) {
    invoiceSettingsCache.delete(teamId);

    return;
  }

  invoiceSettingsCache.clear();
}

export function fetchTeamInvoiceSettings(teamId, options = {}) {
  const { force = false, ...apiOptions } = options;
  const cached = invoiceSettingsCache.get(teamId);

  if (!force && cached) {
    return cached;
  }

  const promise = apiFetch(`/teams/invoice-settings/${teamId}`, apiOptions).catch((err) => {
    invoiceSettingsCache.delete(teamId);
    throw err;
  });

  invoiceSettingsCache.set(teamId, promise);

  return promise;
}
